import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { apiFetch } from '../utils/api';

const AdminDashboard = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const { theme } = useTheme();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await apiFetch('/api/analytics');
        const data = await res.json();
        if (res.ok) {
          setStats(data);
        } else {
          if (res.status === 401) {
            navigate('/login');
          }
          setStats({ totalOrders: 0, totalProducts: 0, totalUsers: 0, totalRevenue: 0 });
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchStats();
  }, [user, navigate]);

  const cardStyle = {
    padding: '25px',
    background: 'var(--color-surface, #18181b)',
    border: '1px solid var(--color-border-light, rgba(255, 255, 255, 0.05))',
    borderRadius: '12px',
    boxShadow: '0 4px 20px var(--shadow-card, rgba(0,0,0,0.3))',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '10px'
  };

  const numberStyle = {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: '#f97316'
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '5px' }}>
        <img src={theme === 'light' ? '/RegardTraderLogo_black.png' : '/RegardTradersLogo.png'} alt="Logo" style={{ height: '40px', width: '40px', borderRadius: '8px', objectFit: 'cover', filter: 'drop-shadow(0 0px 10px rgba(249, 115, 22, 0.3))' }} />
        <h2 style={{ margin: 0 }}>Admin Dashboard</h2>
      </div>
      <p style={{ color: 'var(--color-text-secondary, #a1a1aa)', marginBottom: '30px', fontSize: '1.1rem' }}>Welcome back, <span style={{color: 'var(--color-text, #fff)'}}>{user?.name}</span></p>
      
      {stats ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
          <div style={cardStyle}>
            <h4 style={{ color: 'var(--color-text-secondary, #a1a1aa)', fontSize: '1.05rem', margin: 0 }}>Total Orders</h4>
            <div style={numberStyle}>{stats.totalOrders}</div>
          </div>
          <div style={cardStyle}>
            <h4 style={{ color: '#f97316', fontSize: '1.05rem', margin: 0 }}>Pending</h4>
            <div style={{ ...numberStyle, color: '#f97316' }}>{stats.pendingVerificationOrders || 0}</div>
          </div>
          <div style={cardStyle}>
            <h4 style={{ color: '#a855f7', fontSize: '1.05rem', margin: 0 }}>Processing</h4>
            <div style={{ ...numberStyle, color: '#a855f7' }}>{stats.processingOrders || 0}</div>
          </div>
          <div style={cardStyle}>
            <h4 style={{ color: '#6366f1', fontSize: '1.05rem', margin: 0 }}>Shipped</h4>
            <div style={{ ...numberStyle, color: '#6366f1' }}>{stats.shippedOrders || 0}</div>
          </div>
          <div style={cardStyle}>
            <h4 style={{ color: '#10b981', fontSize: '1.05rem', margin: 0 }}>Delivered</h4>
            <div style={{ ...numberStyle, color: '#10b981' }}>{stats.deliveredOrders || 0}</div>
          </div>
          <div style={{ ...cardStyle, border: '1px solid rgba(255, 122, 0, 0.2)' }}>
            <h4 style={{ color: '#ff7a00', fontSize: '1.05rem', margin: 0 }}>Revenue</h4>
            <div style={{ ...numberStyle, color: '#ff7a00' }}>₹{(stats.totalRevenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: 'center', margin: '50px 0', color: '#f97316' }}>Loading metrics...</div>
      )}

      <div style={{ marginTop: '40px', padding: '30px', background: 'var(--color-surface-1)', borderRadius: '12px', border: '1px solid var(--color-border-light, rgba(255,255,255,0.05))' }}>
        <h3 style={{ marginBottom: '25px', color: '#f97316' }}>Administrative Controls</h3>
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
          <button className="btn" onClick={() => navigate('/admin/add-product')}>+ Add Product</button>
          <button className="btn" onClick={() => navigate('/admin/products')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>📦 Manage Products</button>
          <button className="btn" onClick={() => navigate('/admin/categories')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>🗂️ Manage Categories</button>
          <button className="btn" onClick={() => navigate('/admin/orders')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>🚚 Manage Orders</button>
          <button className="btn" onClick={() => navigate('/admin/bills')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>🧾 Manage Bills</button>
          <button className="btn" onClick={() => navigate('/admin/users')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>👥 Users Directory</button>
          <button className="btn" onClick={() => navigate('/admin/coupons')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>🏷️ Manage Coupons</button>
          <button className="btn" onClick={() => navigate('/admin/announcement-bar')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>📢 Announcement Bar</button>
          <button className="btn" onClick={() => navigate('/admin/promotional-popup')} style={{ background: 'var(--btn-secondary-bg, #3f3f46)', color: 'var(--color-text-primary)' }}>✨ Promotional Popup</button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
